<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head back="Convention.Schedule.Browse" :title="item.name" :image="item.image" />

	<app-content-body :is-grid="4" :loading="is.loading && is.initialised" v-if="is.initialised">

		<app-widget-summary :cancelled="item.cancelled" :headless="true" :span="3" :text="item.description" :image="item.image" :metrics="metrics" />

		<app-widget-info :cancelled="item.cancelled" :items="info" />

		<com-seats title="Seats" :seats="item.seats" v-if="item.seats.total > 0" />

		<app-widget-chat :span="2" :id="item.id" />

		<app-widget-activity :span="2" :id="item.id" />

	</app-content-body>

</app-content>

</template>

<script>

import mixItem from '@/mixin/item'

export default {

	mixins: [mixItem],

	components: {
		'com-seats': () => import('./conventionscheduleevent/Seats')
	},

	data: function() {

		return {
			endpoint: 'convention/schedule/event',
			live: 'convention/schedule/event'
		}

	},

	created: function() {

		this.load()

	},

	computed: {

		metrics: function() {

			return [
				{
					type: 'info',
					disabled: !this.item.type.games.enabled,
					avatar: this.item.host.avatar,
					forceAvatar: true,
					text: 'Host',
					value: this.item.host.name
				},
				{
					type: 'info',
					text: 'Type',
					value: this.item.type.name
				},
				{
					type: 'info',
					text: 'Experience',
					disabled: !this.item.type.games.enabled,
					tooltip: this.$constants.experience.tooltip[this.item.experience],
					value: this.$constants.schedule.experienceShort[this.item.experience] + ((this.item.teacher) ? ' (Teacher wanted)' : '')
				},
				{
					type: 'info',
					text: 'Age',
					value: this.$constants.schedule.ageShort[this.item.age]
				}
			]

		},

		info: function() {

			return [
				{
					icon: 'day',
					label: 'On',
					text: this.$filter('formatDate', this.item.date, 'dddd')
				},
				{
					icon: 'time',
					label: 'At',
					text: this.$filter('formatDate', this.item.date, this.$hourFormat)
				},
				{
					icon: 'duration',
					label: 'For',
					text: this.$filter('hours', this.item.duration) + ' hour' + ((this.item.duration === 3600) ? '' : 's')
				},
				{
					icon: 'location',
					label: 'In',
					text: this.item.location
				},
			]

		}

	}

}

</script>

<style scoped>

</style>